import { WidgetTranslations } from '@/data.ts'
import { DepartureGroup } from '@/lib/departures.ts'
import { DepartureListItem } from '@/components/departure-list-item.tsx'
import { cn } from '@/lib/cn.ts'
import { FullyBookedListGroup } from '@/components/fully-booked-departure.tsx'

export function DepartureListGroup ({
  departureGroup,
  translations,
  maxVisible
}: {
  departureGroup: DepartureGroup
  translations: WidgetTranslations
  maxVisible: number
}): JSX.Element {
  if (departureGroup.status === 'fully_booked') {
    return (
      <FullyBookedListGroup
        departureGroup={departureGroup}
        translations={translations}
        className={cn('group', {
          hidden: maxVisible <= departureGroup.index
        })}
      />
    )
  } else {
    return (
      <>
        {departureGroup.departures.map((departure, index: number) => (
          <DepartureListItem
            key={departure.id} departure={departure} translations={translations}
            data-date={departure.start_date} data-id={departure.id}
            className={cn('group', {
              hidden: maxVisible <= departureGroup.index + index
            })}
          />))}
      </>
    )
  }
}
